import { getTenantSubdomainFromHostname } from "~/utils/public-store-host"
import { useOfflinePosConnectivity } from "~/composables/useOfflinePosConnectivity"

export default defineNuxtRouteMiddleware((to) => {
	if (process.server || useOfflinePosConnectivity().value || to.path === "/") return

	const config = useRuntimeConfig()
	const tenant = getTenantSubdomainFromHostname(
		String(window.location.hostname || "").toLowerCase(),
		String(config.public.baseDomain || "").toLowerCase(),
		{
			appSubdomain: config.public.appSubdomain,
			reservedSubdomains: config.public.reservedSubdomains,
		}
	)
	if (!tenant) return navigateTo("/")
})
